<div
  fxHide
  fxShow.gt-xs
>
  <app-map-plan-building-base
    [project]="project"
    [buildingFloors]="buildingFloors"
  >
  </app-map-plan-building-base>
  <app-touch-guide></app-touch-guide>
</div>

<section
  fxShow
  fxHide.gt-xs
  fxLayout="column"
  fxLayout.gt-sm="row"
  fxLayoutAlign="center center"
  fxLayoutGap="15px"
  style="margin: 20px 0;"
>
  <h1>
    {{ project.name }}
  </h1>
  <a
    *ngFor="let buildingFloor of buildingFloors, trackBy: listTrackingService.disableUpdate"
    mat-raised-button
    color="main-color"
    [href]="(basePath == '/' ? '' : basePath) + '/bloc/' + project.id + '/' + buildingFloor.id"
  >
    {{ buildingFloor.floor_value }}
  </a>
</section>



// WEBPACK FOOTER //
// ./src/app/buildings/buildings.component.html